import supabase from 'modules/core/supabase/supabase';

export async function getScore(matchId: number) {
  const data = await supabase.matchChronology.getRow(matchId);
  const firstTeam = data?.firstTeamScore ?? 0;
  const secondTeam = data?.secondTeamScore ?? 0;
  return { first: firstTeam, second: secondTeam };
}
